module.exports = __webpack_public_path__ + "img/introduction_pic01.c97472d2.png";